import { Press, cx } from '@dorixona/ui'

export interface SegmentedOption<T extends string> {
  value: T
  label: string
}

export interface SegmentedProps<T extends string> {
  label: string
  options: readonly SegmentedOption<T>[]
  value: T | undefined
  onChange: (value: T) => void
  describedBy?: string
  required?: boolean
}

/**
 * Выбор из двух-трёх вариантов. Для диктора — радиогруппа, для пальца —
 * обычные нажимаемые сегменты с отдачей выбора.
 */
export function Segmented<T extends string>({
  label,
  options,
  value,
  onChange,
  describedBy,
  required,
}: SegmentedProps<T>) {
  return (
    <div
      className="segchoice"
      role="radiogroup"
      aria-label={label}
      aria-describedby={describedBy}
      aria-required={required || undefined}
    >
      {options.map((option) => (
        <Press
          key={option.value}
          role="radio"
          squish="chip"
          haptic="select"
          // Варианты рядом и тапают их подряд — сдвиг пальца не свайп.
          cancelOnMove={false}
          // iOS склеивает быстрые тапы в двойной и глотает второй click —
          // выбор идемпотентен, поэтому срабатываем на отпускании.
          trigger="up"
          aria-checked={value === option.value}
          className={cx(value === option.value && 'on')}
          onPress={() => onChange(option.value)}
        >
          {option.label}
        </Press>
      ))}
    </div>
  )
}
